import { theme } from "utils/Theme/theme";

export const italicText = {
    fontStyle: "italic",
};

export const dividerSpacing = {
    margin: theme.spacing(6, 0),
};
